import React, { useState, useEffect } from 'react'; 
import { Table, Checkbox, List, Card, message, Input, Button } from 'antd'; 
import axios from 'axios';

const CDifundir = () => {
  const [mensajes, setMensajes] = useState([]);
  const [filteredMensajes, setFilteredMensajes] = useState([]); // Estado para los mensajes filtrados
  const [selectedNumeros, setSelectedNumeros] = useState([]);
  const [mensaje, setMensaje] = useState(''); // Estado para el mensaje
  const [searchQuery, setSearchQuery] = useState(''); // Estado para la búsqueda

  const user = JSON.parse(localStorage.getItem('user'));
  const empresaId = user?.user?.idCooperativa;

  useEffect(() => {
    // Llamada al backend para obtener los números
    const fetchMensajes = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/mensajes/${empresaId}`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        setMensajes(response.data);
        setFilteredMensajes(response.data); // Inicializamos los mensajes filtrados con todos los datos
      } catch (error) {
        console.error('Error al cargar los números de mensajes:', error);
        message.error('Error al cargar los números de mensajes.');
      }
    };

    fetchMensajes();
  }, []);

  const handleCheckboxChange = (record) => {
    const isSelected = selectedNumeros.some((num) => num === record.numero);

    if (isSelected) {
      setSelectedNumeros(selectedNumeros.filter((num) => num !== record.numero));
    } else {
      setSelectedNumeros([...selectedNumeros, record.numero]);
    }
  };

  const handleSendMessage = async () => {
    if (mensaje.trim() === '') {
      message.error('El mensaje no puede estar vacío.');
      return;
    }

    if (selectedNumeros.length === 0) {
      message.error('Debe seleccionar al menos un número.');
      return;
    }

    const data = {
      mensaje: mensaje,
      numeros: selectedNumeros,
    };

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      
      const response = await axios.post('https://bot-coop.onrender.com/difundir', data, config);
      message.success('Mensaje enviado correctamente.');
    } catch (error) {
      console.error('Error al enviar el mensaje:', error);
      message.error('Error al enviar el mensaje.');
    }
  };

  // Filtra los números según el valor ingresado en el campo de búsqueda
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    
    const filteredData = mensajes.filter((mensaje) =>
      mensaje.numero.includes(query) // Filtra por coincidencia en el número
    );
    setFilteredMensajes(filteredData);
  };

  const columns = [
    {
      title: '',
      dataIndex: 'checkbox',
      key: 'checkbox',
      render: (_, record) => (
        <Checkbox
          checked={selectedNumeros.includes(record.numero)}
          onChange={() => handleCheckboxChange(record)}
        />
      ),
    },
    {
      title: 'Número de Teléfono',
      dataIndex: 'numero',
      key: 'numero',
    },
  ];

  return (
    <div className="p-4">
      <Card title="Difundir Mensajes" className="mb-4">
        {/* Campo de texto para el mensaje */}
        <Input.TextArea
          rows={4}
          value={mensaje}
          onChange={(e) => setMensaje(e.target.value)}
          placeholder="Escribe tu mensaje aquí..."
        />

        {/* Campo de búsqueda para filtrar los números */}
        <Input
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Buscar por número de teléfono"
          style={{ marginTop: '16px', marginBottom: '16px' }}
        />

        {/* Tabla con los números filtrados */}
        <Table
          dataSource={filteredMensajes}
          columns={columns}
          rowKey="numero"
          pagination={{ pageSize: 5 }}
        />

        {/* Lista de números seleccionados */}
        <Card title="Números Seleccionados" style={{ marginTop: '16px' }}>
          <List
            dataSource={selectedNumeros}
            renderItem={(item) => <List.Item>{item}</List.Item>}
            locale={{ emptyText: 'No hay números seleccionados.' }}
          />
        </Card>

        {/* Botón para enviar el mensaje */}
        <Button
          type="primary"
          onClick={handleSendMessage}
          style={{ marginTop: '16px' }}
        >
          Enviar Mensaje
        </Button>
      </Card>
    </div>
  );
};

export default CDifundir;